import { z } from 'zod';
import { getPasswordValidationErrors } from '@/features/auth/shared/helpers/get-password-validation-errors';
import { accountFieldSchemas } from '@/features/account/shared/types/account-field-schemas';

export const createAccountFormSchema = z
  .object({
    firstName: accountFieldSchemas.buildFirstName({ required: false, allowEmptyLiteral: true }),
    email: accountFieldSchemas.buildEmail(),
    password: accountFieldSchemas.buildRequiredPasswordField({
      requiredMessage: 'errors.passwordRequired',
    }),
    subscribeToNewsletter: z.boolean(),
  })
  .superRefine((form, ctx) => {
    const passwordError = getPasswordValidationErrors(form.password);
    if (passwordError) {
      ctx.addIssue({
        path: ['password'],
        message: passwordError,
        code: z.ZodIssueCode.custom,
      });
    }
  });

export type CreateAccountFormValues = z.infer<typeof createAccountFormSchema>;
